import { lazyRouteComponent } from "@tanstack/react-router";
import { Sparkles } from "lucide-react";
import { lazy, Suspense } from "react";

import type { PageDef } from "@/app/registry";
import { brand } from "@/brand";

import { parseAiSearch, parseTradesSearch } from "./search";

export {
  AI_TABS,
  PAPER_LEGS,
  parseAiSearch,
  type AiSearch,
  type AiTab,
  type PaperLeg,
} from "./search";

/** The AI paper trades page: the "<brand> AI" main menu. */
export const AI_TRADES_PATH = "/app/ai-trades";

export const pages: PageDef[] = [
  {
    // Every paper trade in one place: AI (intraday and evening) and the admin's
    // Paper Trade broadcasts. Admins and users ticked for AI (the server checks too).
    path: AI_TRADES_PATH,
    proOnly: true,
    title: `${brand.name} AI`,
    component: lazyRouteComponent(() => import("./AiTradesPage"), "AiTradesPage"),
    nav: {
      label: "AI paper trades",
      icon: Sparkles,
      group: "AI",
      order: 0,
      badge: NavBadge,
      highlight: true,
    },
    validateSearch: parseTradesSearch,
    aiAccess: true,
  },
  {
    // the old "AI paper trades" page: now part of the page above
    path: "/app/ai-calls",
    proOnly: true,
    title: `${brand.name} AI`,
    component: lazyRouteComponent(() => import("./Redirects"), "ToAiTrades"),
    aiAccess: true,
  },
  {
    // the old "AI research" page (candidates, models, track record): admins only,
    // now Admin → AI model; everyone else gets the admin-page note
    path: "/app/ai",
    title: "AI model",
    component: lazyRouteComponent(() => import("./Redirects"), "ToAiModel"),
    validateSearch: parseAiSearch,
    ownerOnly: true,
  },
];

const LazyBadge = lazy(() => import("./LiveCallsPage").then((m) => ({ default: m.LiveBadge })));

/** The count of new paper-trade updates next to the menu entry. */
function NavBadge() {
  return (
    <Suspense fallback={null}>
      <LazyBadge />
    </Suspense>
  );
}
